import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const BarChartGraph = ({ data }) => {
  // Format data for Recharts
  const chartData = Object.entries(data || {}).map(([date, entries]) => {
    const dataPoint = { name: date };
    (entries || []).forEach((entry) => {
      dataPoint[`dailyMWp_${entry.wattage}`] = entry.dailyMWp;
    });
    return dataPoint;
  });

  // Get list of unique wattages
  const wattages = [
    ...new Set(
      Object.values(data || {})
        .flat()
        .map((entry) => entry.wattage)
    ),
  ];

  // Define colors for bars
  const colors = ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"];

  return (
    <div style={{ width: "100%", height: 400 }}>
      <h3>Daily Power Generation by Wattage</h3>
      <ResponsiveContainer>
        <BarChart
          data={chartData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tick={{ fontSize: 12 }} />
          <YAxis label={{ value: "Daily MWp", angle: -90, position: "insideLeft" }} />
          <Tooltip />
          <Legend />
          {wattages.map((wattage, index) => (
            <Bar
              key={wattage}
              dataKey={`dailyMWp_${wattage}`}
              fill={colors[index % colors.length]}
              name={`${wattage}W`}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChartGraph;